/**
 *
 * @module pageMeta
 * @description This module provides data from the page's meta tags when the page is loaded.
 *
 */

/* global module */

(function(root, factory) {

    if (typeof define === 'function' && define.amd) {
        define('pageMeta/pageMeta',[], factory);
    } else if (typeof exports === 'object') {
        module.exports = factory();
    } else {
        root.bamPageMeta = factory();
    }

}(this, function() {

    'use strict';

    var meta = document.querySelectorAll('meta');
    var metaSet = Array.prototype.slice.call(meta);
    var exports = {};

    // iterate over all the meta tags assigning them to exports.
    metaSet.forEach(function(meta, index) {

        var key = meta.getAttribute('name') || meta.getAttribute('property');

        if (key) {

            var overrideKey = 'bam-override-' + key + '=';
            var overrideIndex = window.location.href.indexOf(overrideKey);

            if (overrideIndex !== -1) {

                var overrideVal = window.location.href.substr(overrideIndex+overrideKey.length);
                var nextAmp = overrideVal.indexOf('&');

                if (nextAmp !== -1) {
                    overrideVal = overrideVal.substr(0, nextAmp);
                }

                exports[key] = overrideVal;

            } else {

                exports[key] = meta.getAttribute('content');

            }

            switch(meta.getAttribute('data-type')) {
                case 'json':
                    exports[key] = JSON.parse(exports[key]);
            }

        }

    });

    return exports;

}));

